import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AppMobileNavBarComponent } from './appmobile-navbar.component';
import { EquisButtonModule } from '@tn-equis/core/components/button';

@NgModule({
  declarations: [AppMobileNavBarComponent],
  imports: [CommonModule, EquisButtonModule],
  exports: [AppMobileNavBarComponent],
})
export default class AppMobileNavBarModule {}
